import { spesa, tipologia_spesa, user } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { FormProps } from '@/types'
import { FormRef } from 'devextreme-react/cjs/form'
import React from 'react'

export type ExpenseEditorProps = {
  creating: boolean
}

export interface ExpenseEditorFormProps extends FormProps {
  expense: spesa
  impiegati: user[]
  tipologie: tipologia_spesa[]
  formRef: React.RefObject<FormRef>
  onSaveClick: () => Promise<void>
}

export enum TipologiaSpesa {
  'VITTO' = 1,
  'ALLOGGIO',
  'TRASFERTA',
}
